import { BaseMessageInfo } from "./BaseMessageInfo";
import { OrderBus } from "./OrderBus";
import { OrderDetailsBus } from "./OrderDetailsBus";
import { OrderReceiveBus } from "./OrderReceiveBus";
import { CommonFunctions } from "../static/common-functions";

export class OrderMessageInfo extends BaseMessageInfo
{
    constructor(data: OrderMessageInfo = null) {
        super(data);
        if (CommonFunctions.hasArrayElementValue(data.orderDetailItems)) {
            let arr = [];
            for (let i = 0; i < data.orderDetailItems.length; i++) {
                let busObj: OrderDetailsBus = new OrderDetailsBus(data.orderDetailItems[i]);
                arr.push(busObj);
            }
            this.orderDetailItems = arr;
        }
        if (CommonFunctions.hasArrayElementValue(data.orderReceived)) {
            let arr = [];
            for (let i = 0; i < data.orderReceived.length; i++) {
                let busObj: OrderReceiveBus = new OrderReceiveBus(data.orderReceived[i]);
                arr.push(busObj);
            }
            this.orderReceived = arr;
        }
    }
    orderBus: OrderBus ;
    orderDetailsBus: OrderDetailsBus;
    orderDetailItems: OrderDetailsBus[];
    orderDetails: OrderDetailsBus;
    orderId: any;
    orderNumber: string;
    isTaxExempt: boolean;
    taxExemptText: string;
    orderReceived: OrderReceiveBus[];
}
